// src/components/AdminPaymnt.jsx
import React, { useEffect, useState } from 'react';

const AdminPayment = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        // Utilisation de la route correcte
        const response = await fetch('https://api.nms06.com/api/paypal/payments');
        if (!response.ok) {
          throw new Error('Erreur lors de la récupération des données');
        }
        const data = await response.json();
        setPayments(data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPayments();
  }, []);

  if (loading) {
    return <div>Chargement...</div>;
  }

  if (error) {
    return <div>Erreur : {error.message}</div>;
  }

  return (
    <div>
      <h1>Liste des paiements</h1>
      {payments.length === 0 ? (
        <p>Aucun paiement trouvé.</p>
      ) : (
        <table border="1" cellPadding="5" cellSpacing="0">
          <thead>
            <tr>
              <th>ID</th>
              <th>Order ID</th>
              <th>Transaction ID</th>
              <th>Status</th>
              <th>Amount</th>
              <th>Currency</th>
              <th>Created At</th>
              <th>Updated At</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>Type</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((payment) => (
              <tr key={payment.id}>
                <td>{payment.id}</td>
                <td>{payment.order_id}</td>
                <td>{payment.transaction_id || '-'}</td>
                <td>{payment.status || '-'}</td>
                <td>{payment.amount}</td>
                <td>{payment.currency || '-'}</td>
                <td>{payment.created_at}</td>
                <td>{payment.updated_at}</td>
                <td>{payment.first_name || '-'}</td>
                <td>{payment.last_name}</td>
                <td>{payment.email}</td>
                <td>{payment.type}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AdminPayment;
